module.exports = __webpack_public_path__ + "img/web5.e180e984.svg";